import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Password ", -1)
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " New Password ", -1)
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "body-text-lg text-w-bold" }, " Confirm New Password ", -1)
const _hoisted_7 = { class: "button-container grid-x align-center" }
const _hoisted_8 = { class: "cell small-12 large-6" }

import { ref } from "vue";
import { FormInst, NForm, NFormItem, NInput, NButton, FormRules, FormItemRule } from 'naive-ui';
import { UpdatePasswordType } from "@/ts/interfaces";
import { useUserPasswordUpdateStore } from "@/stores/client/update-password.store";



export default /*#__PURE__*/_defineComponent({
  __name: 'NewPasswordForm',
  setup(__props) {

const formData = ref<UpdatePasswordType>({
  password: '',
  new_password: '',
  new_password_confirmation: ''
})

const userPasswordUpdateStore = useUserPasswordUpdateStore()

const passwordFormRef = ref<FormInst | null>(null)

const newPasswordRules : FormRules = {
  password: [{
    required: true,
    message: 'Password is required',
    trigger: ['input', 'blur']
  }],
  new_password: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('New password is required')
      } else if (value === formData.value.password) {
        return new Error('New password has to be different than the current password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }],
  new_password_confirmation: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('New password confirmation is required')
      } else if (value !== formData.value.new_password) {
        return new Error('New password confirmation is not the same as new password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }]
}
const submit = () => {
  passwordFormRef.value?.validate((errors) => {
    if (!errors) {
      userPasswordUpdateStore.edit(formData.value)
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NForm), {
    ref_key: "passwordFormRef",
    ref: passwordFormRef,
    model: formData.value,
    rules: newPasswordRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(NFormItem), {
          label: "Password",
          path: "password",
          feedback: _unref(userPasswordUpdateStore).status === 2 ? _unref(userPasswordUpdateStore).errors?.errors?.password[0] : '',
          "validation-status": _unref(userPasswordUpdateStore).status === 2 ? 'error' : 'success'
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formData.value.password,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.password) = $event)),
              size: "medium",
              round: "",
              placeholder: "Type your current password",
              class: "form-input",
              type: "password",
              "show-password-on": "click"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["feedback", "validation-status"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(NFormItem), {
          label: "New Password",
          path: "new_password"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formData.value.new_password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.new_password) = $event)),
              size: "medium",
              round: "",
              placeholder: "Type your new password",
              class: "form-input",
              type: "password",
              "show-password-on": "click"
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(NFormItem), {
          label: "Confirm New Password",
          path: "new_password_confirmation"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formData.value.new_password_confirmation,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.new_password_confirmation) = $event)),
              size: "medium",
              round: "",
              placeholder: "Confirm your new password",
              class: "form-input",
              type: "password",
              "show-password-on": "click"
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(NButton), {
            onClick: _withModifiers(submit, ["prevent"]),
            class: "new-project-button",
            size: "large",
            tabindex: "0",
            loading: _unref(userPasswordUpdateStore).status === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SAVE ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})